import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  async connect() {
    const { default: Sortable } = await import("sortablejs")
    if (!this.element.isConnected) return
    const tbody = this.element.querySelector("tbody")
    if (!tbody) return

    this.sortable = Sortable.create(tbody, {
      handle: ".drag-handle",
      animation: 150,
      ghostClass: "table-active",
      onEnd: () => this.#persist(),
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async #persist() {
    if (this.persisting) return
    this.persisting = true
    this.sortable?.option("disabled", true)

    const rows = this.element.querySelectorAll("tbody tr[data-service-id]")
    const serviceIds = Array.from(rows, (row) => row.dataset.serviceId)

    this.element.querySelectorAll(".service-order").forEach((el, i) => {
      el.textContent = i + 1
    })

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(this.urlValue, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": token,
        },
        body: JSON.stringify({ service_ids: serviceIds }),
      })
      // A redirected response means the server returned HTML (validation failure
      // or session expiry) rather than the expected 204. Reload to show the
      // correct server-side state and any flash message.
      if (!response.ok || response.redirected) {
        window.location.reload()
      }
    } catch {
      window.location.reload()
    } finally {
      this.persisting = false
      this.sortable?.option("disabled", false)
    }
  }
}
